import { useMsal } from '@azure/msal-react';
import { useClients } from '../../context/ClientContext';
// import { useAgents } from '../../context/AgentContext';
import { Dropdown, MenuProps, Space, Button, Typography } from 'antd';
import styles from './WorkspaceHeader.module.scss';
import { DownOutlined, LogoutOutlined } from '@ant-design/icons';
import { BRAND_SHORT } from '../../constants/branding';
import { MouseEvent, useCallback } from 'react';
import { handleSessionExpiry } from '../../utils/sessionGuard';
import { logoutBackend } from '../../apis/authApi';

interface WorkspaceHeaderProps {
  onBrandClick?: () => void;
}

const WorkspaceHeader = ({ onBrandClick }: WorkspaceHeaderProps) => {
  const { accounts, instance } = useMsal();
  const acct = accounts[0];
  const { clients, activeClient, setActiveClientId } = useClients();
  //const { agents, activeAgent, setActiveAgentId } = useAgents();

  const clientItems: MenuProps['items'] = clients.map((c) => ({ key: c.id, label: c.name, onClick: () => setActiveClientId(c.id) }));
  //const agentItems: MenuProps['items'] = agents.map((a) => ({ key: a.id, label: a.name, onClick: () => setActiveAgentId(a.id) }));

  const handleLogout = useCallback(async () => {
    try {
      await logoutBackend();
    } catch {
      // Best-effort — server session will expire on its own
    }
    await handleSessionExpiry(instance);
    await instance.logoutRedirect();
  }, [instance]);

  return (
    <div className={`h-[54px] flex items-center justify-between px-4 bg-[#1F2937] border-b border-[#414756] ${styles.brandWrap}`}>
      <div className="flex items-center gap-6">
        <Typography.Text
          className={styles.brandText}
          onClick={(event: MouseEvent) => {
            event.preventDefault();
            onBrandClick?.();
          }}
          aria-label="Rubix home"
        >
          {BRAND_SHORT}
        </Typography.Text>
        <Space size={16}>
          <Dropdown menu={{ items: clientItems }} trigger={['click']}>
            <Button>
              {activeClient?.name} <DownOutlined />
            </Button>
          </Dropdown>
        </Space>
      </div>
      <div className="flex items-center gap-3">
        <Typography.Text className="text-white">{acct?.username || 'Guest'}</Typography.Text>
        <Button icon={<LogoutOutlined />} size="small" onClick={handleLogout}>
          Logout
        </Button>
      </div>
    </div>
  );
};
export default WorkspaceHeader;
